// graphql/mutations/publishTrip.ts
import { gql } from "@apollo/client";

export const PUBLISH_TRIP = gql`
  mutation PublishTrip($tripPublicationId: String!) {
    MT_PUBLISH_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId) {
      code
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const UPDATE_TRIP_PUBLICATION = gql`
  mutation UpdateTripPublication(
    $tripPublicationId: String!
    $tripPublicationInput: TripPublicationInput!
  ) {
    MT_UPDATE_TRIP_PUBLICATION(
      tripPublicationId: $tripPublicationId
      tripPublicationInput: $tripPublicationInput
    ) {
      code
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const GET_TRIP_PUBLICATION = gql`
  query QR_GET_TRIP_PUBLICATION($tripPublicationId: String!) {
    QR_GET_TRIP_PUBLICATION(tripPublicationId: $tripPublicationId) {
      code
      data {
        id
        tripId
        status
        childsMaxAge
        babiesMaxAge
        tripDates {
          id
          startDate
          endDate
          nbDays
          nbNight
          isCheapestDate
          isFlightIncluded
          stepsDate {
            date
            stepIds
          }
          adultPricePerPerson {
            value
            currency
          }
          childPricePerPerson {
            value
            currency
          }
          babiesPricePerPerson {
            value
            currency
          }
          seatsAvailable {
            initialNumberOfSeatsAvailable
            initialNumberOfChildrensSeatsAvailable
            initialNumberOfBabiesSeatsAvailable
            numberOfSeatsAvailable
            numberOfChildrensSeatsAvailable
            numberOfBabiesSeatsAvailable
          }
          travelManagers {
            fullName
            email
            phoneNumber {
              indicative
              number
            }
          }
        }
        trip {
          reference
          tripProgramDetails {
            id
            ranking {
              title
            }
          }
        }
      }
      error {
        timestamp
        message
        correlationId
      }
    }
  }
`;

export const publishTrip = async (
  publishTripMutation,
  tripPublicationId,
  accessToken
) => {
  try {
    const { loading, error, data } = await publishTripMutation({
      variables: {
        tripPublicationId,
      },
      context: {
        headers: {
          authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Error publishing Trip:", error.message);
    throw error;
  }
};

export const updateTripPublication = async (
  updateTripPublicationMutation,
  tripPublicationId,
  tripPublicationInput,
  accessToken
) => {
  try {
    const { loading, error, data } = await updateTripPublicationMutation({
      variables: {
        tripPublicationId,
        tripPublicationInput,
      },
      context: {
        headers: {
          authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      },
    });
    return { loading, error, data };
  } catch (error) {
    console.error("Error updating Trip Publication:", error.message);
    throw error;
  }
};
